var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border border-gray-400 overflow-hidden markdown"},[_c('div',{staticClass:"w-full bg-gray-400 text-white p-1"},[_vm._v(_vm._s(_vm.$t("news.manage.markdown_preview")))]),_c('div',{staticClass:"p-4"},[_c('vue-markdown',{attrs:{"source":_vm.text,"anchorAttributes":{
        target: '_blank',
        rel: 'nofollow',
      }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }